"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const useTableProps_1 = require("./useTableProps");
const constants_1 = require("../../constants");
const TableRowElement = styled_1.default.tr((props) => ({
    // NOTE: We need a background color for the `hoverable` prop to work properly:
    backgroundColor: props.selected
        ? constants_1.Color.LIGHTER_BLUE
        : (props.backgroundColor ?? constants_1.Color.WHITE),
    boxShadow: props.selected ? `0 0 0 1px ${constants_1.Color.LIGHT_BLUE} inset` : undefined,
    cursor: props.hoverable ? 'pointer' : undefined,
    transition: `background-color ${constants_1.theme.animation.transition}`,
    userSelect: props.hoverable ? 'none' : undefined,
    '&:first-of-type': {
        '& > :first-of-type': {
            borderTopLeftRadius: constants_1.theme.border.radius.normal - 1,
        },
        '& > :last-of-type': {
            borderTopRightRadius: constants_1.theme.border.radius.normal - 1,
        },
    },
    '&:last-of-type': {
        '& > :first-of-type': {
            borderBottomLeftRadius: constants_1.theme.border.radius.normal - 1,
        },
        '& > :last-of-type': {
            borderBottomRightRadius: constants_1.theme.border.radius.normal - 1,
        },
    },
    '&:nth-of-type(2n)': {
        backgroundColor: props.selected
            ? constants_1.Color.LIGHTER_BLUE
            : props.striped
                ? (props.backgroundColor ?? constants_1.Color.LIGHTEST_BLUE)
                : undefined,
    },
    ':hover': props.hoverable
        ? {
            backgroundColor: props.backgroundColor,
            filter: 'brightness(95%)',
        }
        : undefined,
}));
/**
 * TODO: Fix bottom row border radius on hover.
 */
const TableRow = (props) => {
    const tableProps = (0, useTableProps_1.useTableProps)();
    const striped = tableProps.striped ?? props.striped;
    return ((0, jsx_runtime_1.jsx)(TableRowElement, { backgroundColor: props.backgroundColor, className: props.className, head: props.head, hoverable: props.hoverable, selected: props.selected, striped: striped, onClick: props.onClick, children: props.children }));
};
exports.TableRow = TableRow;
